import { FC, useRef } from 'react'
import { HeaderGroup } from '@tanstack/react-table'
import cn from 'classnames'

import { TableHeaderGroupHeader } from '../table-header-group-header'

//@ts-ignore
import s from '../table.module.scss'

type TableHeaderGroupProps = {
  headerGroup: HeaderGroup<{}>
  isRowsDraggable?: boolean
  isFlex?: boolean
  hasExpandableRows?: boolean
}

const TableHeaderGroup: FC<TableHeaderGroupProps> = props => {
  const { headerGroup, isRowsDraggable, isFlex, hasExpandableRows } = props

  const tableHeaderRowRef = useRef<HTMLTableRowElement>(null)

  return (
    <tr className={cn(s['tr'], { [s['tr-flex']]: isFlex })} ref={tableHeaderRowRef}>
      {/* Carat column header, only if expandable rows */}
      {hasExpandableRows && <th className={s['carat-column']}></th>}
      {headerGroup.headers.map(header => (
        <TableHeaderGroupHeader key={header.id} header={header} isRowsDraggable={isRowsDraggable} isFlex={isFlex} />
      ))}

      {isRowsDraggable && (
        <th
          className={cn(s['th'], s['actions-column'], { [s['th-flex']]: isFlex, [s['actions-column-flex']]: isFlex })}
        >
          <div className={s['th-content']}>Actions</div>
        </th>
      )}
    </tr>
  )
}

export default TableHeaderGroup
